import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal, {moleculeModalSizes} from '@s-ui/react-molecule-modal'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconArrowRight from '@adv-mt/mt-svg-icons/lib/ArrowRight.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconDesktop from '@adv-mt/mt-svg-icons/lib/DesktopOutline.js'
import IconMobile from '@adv-mt/mt-svg-icons/lib/MobileOutline.js'

import {useMessagingContext} from '../useMessagingContext/index.js'
export const FeatureNotAvailableModal = () => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const osName = config.get('osName')
  const IOS_OS_NAME = config.get('IOS_OS_NAME')
  const ANDROID_OS_NAME = config.get('ANDROID_OS_NAME')
  const isIOS = osName === IOS_OS_NAME
  const {storeUrl} = config.get('smartbanner')

  const {setInteractionComponent} = useMessagingContext()

  const handleOnClose = () => setInteractionComponent({component: null, show: false})

  const handleOnClickToApp = () => {
    window.location.href = isIOS ? storeUrl[IOS_OS_NAME] : storeUrl[ANDROID_OS_NAME]
  }

  const isHigherThanMobileResolution = useMediaQuery(useMediaQueryBreakpoints.sm)

  return (
    <MoleculeModal
      closeOnEscKeyDown
      closeOnOutsideClick
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      isOpen
      isPageScrollable={false}
      onClose={handleOnClose}
      size={moleculeModalSizes.LARGE}
    >
      <ModalBasicContent
        stepsContent={[
          {
            buttons: {
              ...(!isHigherThanMobileResolution && {
                cancelButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.CANCEL')
                }
              }),
              confirmButton: {
                color: isHigherThanMobileResolution ? 'primary' : 'accent',
                customCallBack: () => {
                  isHigherThanMobileResolution
                    ? setInteractionComponent({component: null, show: false})
                    : handleOnClickToApp()
                },
                text: isHigherThanMobileResolution ? i18n.t('COMMON.UNDERSTOOD') : i18n.t('COMMON.CONTINUE_ON_APP')
              }
            },
            children: (
              <div className="mt-UserMessages-featureNotAvailableModal">{i18n.t('COMMON.CONTINUE_ON_APP_CNET')}</div>
            ),
            headerImage: (
              <div className="mt-UserMessages-featureNotAvailableModalContentHeaderImageWrapper">
                <IconDesktop size="extraLarge" />
                <div className="mt-UserMessages-featureNotAvailableModalContentHeaderImageWrapperIcon">
                  <IconArrowRight />
                </div>
                <IconMobile size="extraLarge" />
              </div>
            ),
            isVerticallyCentered: true,
            title: i18n.t('COMMON.FEATURE_NOT_AVAILABLE_ON_WEB_PLATFORM'),
            titleMarginBottom: 'l'
          }
        ]}
      />
    </MoleculeModal>
  )
}
